import React from 'react'

const Start = () => {
  return (
    <div>Start</div>
  )
}

export default Start